import { useEffect, useState } from 'react'

/**
 * Waits for a pause in typing before letting a value through.
 *
 * Was copy-pasted into six route files, which is one more than the point at
 * which the next screen that needs it starts guessing at the delay. 300ms is
 * the house figure: short enough that results feel immediate, long enough that
 * a name typed at speed costs one request instead of one per letter.
 */
export const useDebounced = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value)
    }, delayMs)
    return () => {
      clearTimeout(timer)
    }
  }, [value, delayMs])

  return debounced
}
